import { init, track } from "@amplitude/analytics-browser";

export const initializeAmplitude = async () => {
  init(process.env.REACT_APP_AMPLITUDE_API_KEY, { autocapture: true });
};

export const trackEvent = async (eventName, eventProperties = {}) => {
  try {
    track(eventName, {
      ...eventProperties,
      source: "grensa-landing",
      url: window.location.href,
      timestamp: Date.now(),
      version: "2.0.0",
    });
  } catch (error) {
    console.error("Amplitude tracking error:", error);
  }
};
